import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 00A83C35-A726-464B-ACEE-F0D690045C25
 * name zip-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zip-box.svg
 * tags
 * - Files / Folders 
 */
export const ZipBoxIcon = createSvgIcon(<><path d="M14,17H12V15H10V13H12V15H14M14,9H12V11H14V13H12V11H10V9H12V7H10V5H12V7H14M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" /></>, 'ZipBoxIcon');
export default ZipBoxIcon